import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import BlueButton from "../../../Custom UI/Buttons/BlueButton/BlueButton";
import {Translation} from "react-i18next";
import SurveyResponseCell from "../../SurveyResponseCell/SurveyResponseCell";
import i18next from "i18next";
import {
  createLoopableSurveyResponse,
  deleteLoopableSurveyResponse,
  loopableSurveyResponses
} from "../../../actions/surveyResponseDetails";
import SurveyComponent from "../../../containers/SurveyContainer";
import SurveyModal from "../../../Modals/SurveyModal/SurveyModal";

export default class SurveyChildSurveyQuestionCell extends React.Component{
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      menuAnchorElement:null,
      totalLoopableEntries:0,
      selectedSurveyResponse:null,
      surveyResponseToDelete:null,
      completedLoopableEntries:0,
      childSurveyResponsesArray:[]
    };
    if(props.question){
      this.getLoopableSurveyResponses(20, true);
    }
    this.closeMenu = this.closeMenu.bind(this);
    this.finishChildSurvey = this.finishChildSurvey.bind(this);
    this.createChildSurveyResponse = this.createChildSurveyResponse.bind(this);
    this.deleteChildSurveyResponse = this.deleteChildSurveyResponse.bind(this);
    this.getLoopableSurveyResponse = this.getLoopableSurveyResponse.bind(this);
    this.getLoopableSurveyResponses = this.getLoopableSurveyResponses.bind(this);
  }
  
  // Methods
  
  closeMenu(){
    this.setState({menuAnchorElement:null, selectedSurveyResponse:null, surveyResponseToDelete:null});
  }
  
  finishChildSurvey(){
    this.getLoopableSurveyResponse();
    this.setState({selectedSurveyResponse:null});
  }
  
  getLoopableSurveyResponse(){
    const {userId, question, isTestResponse, surveyResponseId, loopableSurveyResponse} = this.props;
    const {selectedSurveyResponse} = this.state;
    
    loopableSurveyResponse(userId, surveyResponseId, question.key, isTestResponse, selectedSurveyResponse.child_survey_response_id).then((newResult) => {
      const {childSurveyResponsesArray} = this.state;
      const surveyResponse = newResult.data.data.loop_survey_response;
      const total = surveyResponse.total;
      const completedLoopableEntries = surveyResponse.completed_loopable_entries;
      
      for(let index = 0; index < childSurveyResponsesArray.length; index += 1){
        let loopableSurveyResponse = childSurveyResponsesArray[index];
        
        if(loopableSurveyResponse.child_survey_response_id === surveyResponse.child_survey_response_id){
          childSurveyResponsesArray[index] = surveyResponse;
          break
        }
      }
      this.setState({totalLoopableEntries:total, completedLoopableEntries:completedLoopableEntries, childSurveyResponsesArray:[...childSurveyResponsesArray]});
    }, (newError) => {
    
    });
  }
  
  getLoopableSurveyResponses(aLimit = 20, aReload = false){
    const {userId, question, isTestResponse, surveyResponseId, loopableSurveyResponses} = this.props;
    const {totalLoopableEntries, childSurveyResponsesArray} = this.state;
    
    if(aReload || totalLoopableEntries > childSurveyResponsesArray.length){
      loopableSurveyResponses(userId, surveyResponseId, question.key, isTestResponse, aLimit, aReload ? 0 : childSurveyResponsesArray.length).then((newResult) => {
        const total = newResult.data.data.loop_survey_responses.total;
        const completedLoopableEntries = newResult.data.data.loop_survey_responses.completed_loopable_entries;
        const newChildSurveyResponsesArray = newResult.data.data.loop_survey_responses.array;
        const originalChildSurveyResponsesArray = aReload ? [] : [...childSurveyResponsesArray];
        
        this.setState({
          totalLoopableEntries:total,
          completedLoopableEntries:completedLoopableEntries,
          childSurveyResponsesArray:[...originalChildSurveyResponsesArray, ...newChildSurveyResponsesArray]
        });
      }, (newError) => {
      
      });
    }
  }
  
  createChildSurveyResponse(){
    const {userId, question, isTestResponse, surveyResponseId, createLoopableSurveyResponse} = this.props;
    
    createLoopableSurveyResponse(userId, surveyResponseId, question.key, isTestResponse).then((newResult) => {
      const {childSurveyResponsesArray} = this.state;
      const surveyResponse = newResult.data.data.createLoopSurveyResponse;
      const total = surveyResponse.total;
      const completedLoopableEntries = surveyResponse.completed_loopable_entries;
      childSurveyResponsesArray.push(surveyResponse)
      this.setState({totalLoopableEntries:total, completedLoopableEntries:completedLoopableEntries, selectedSurveyResponse:surveyResponse, childSurveyResponsesArray:[...childSurveyResponsesArray]});
    }, (newError) => {
    
    });
  }
  
  deleteChildSurveyResponse(aChildSurveyResponse){
    const {userId, isTestResponse, surveyResponseId, deleteLoopableSurveyResponse} = this.props;
    // export function deleteLoopableSurveyResponse(aPatientId, aSurveyResponseId, aChildSurveyResponseId = null, aIsTestResponse = false, aLoopReference = null, aIndex = null){
    
    deleteLoopableSurveyResponse(userId, surveyResponseId, aChildSurveyResponse.child_survey_response_id, isTestResponse).then((newResult) => {
      const {childSurveyResponsesArray} = this.state;
      const deletedSurveyResponse = newResult.data.data.deleteLoopSurveyResponse;
      const total = deletedSurveyResponse.total;
      const completedLoopableEntries = deletedSurveyResponse.completed_loopable_entries;
      
      for(let index = 0; index < childSurveyResponsesArray.length; index += 1){
        let loopableSurveyResponse = childSurveyResponsesArray[index];
        
        if(loopableSurveyResponse.child_survey_response_id === aChildSurveyResponse.child_survey_response_id){
          childSurveyResponsesArray.splice(index, 1);
          break
        }
      }
      this.setState({totalLoopableEntries:total, completedLoopableEntries:completedLoopableEntries, childSurveyResponsesArray:[...childSurveyResponsesArray]});
    }, (newError) => {
    
    });
  }
  
  // Render
  
  render(){
    const {menuAnchorElement, selectedSurveyResponse, surveyResponseToDelete, childSurveyResponsesArray} = this.state;
    const {userId, adminId, company, disabled, question, addDataQuery, isTestResponse} = this.props;
    const {key, child_survey_id} = question;
    
    return(
      <div className="survey-skip-cell"
           key={'survey-child-survey-question-cell-' + key}>
        {(childSurveyResponsesArray && childSurveyResponsesArray.map((surveyResponse, index) => {
          return (
            <SurveyResponseCell key={'child-' + surveyResponse.id + '-' + index}
                                onClick={() => this.setState({selectedSurveyResponse:surveyResponse})}
                                surveyResponse={surveyResponse.child_survey_response}
                                menuButtonClicked={(aEvent) => this.setState({menuAnchorElement:aEvent.currentTarget, surveyResponseToDelete:surveyResponse})}
            />
          )}))}
        
        <BlueButton className="add-button"
                    name={<Translation>{(t, {i18n}) => t('ADD')}</Translation>}
                    onClick={() => this.createChildSurveyResponse()}
                    disabled={disabled}
        />
        
        <SurveyModal open={selectedSurveyResponse !== null}
                     finish={() => this.finishChildSurvey()}
                     userId={userId}
                     adminId={adminId}
                     company={company}
                     editable={!disabled}
                     surveyId={child_survey_id}
                     addDataQuery={addDataQuery ? (aSurveyResponseDetailsId) => addDataQuery(aSurveyResponseDetailsId) : null}
                     isTestResponse={isTestResponse}
                     surveyResponseId={selectedSurveyResponse ? selectedSurveyResponse.id : null}
        />
        
        <Menu id="child-survey-responses-menu"
              open={Boolean(menuAnchorElement)}
              style={{zIndex:99999}}
              onClose={() => this.closeMenu()}
              anchorEl={menuAnchorElement}
              keepMounted>
          <MenuItem style={{position:'relative'}}
                    onClick={() => {
                      this.deleteChildSurveyResponse(surveyResponseToDelete);
                      this.closeMenu();
                    }}>
            <Translation>{ (t, { i18n }) => t('DELETE')}</Translation>
          </MenuItem>
        </Menu>
      </div>
    )
  }
}
